module.exports = __webpack_public_path__ + "static/media/media_img.2fc6da95.jpg";